// extracted by css-extract-rspack-plugin
export default {"cls1":"ActiveState-cls1_Pr1","cls2":"ActiveState-cls2_-G0 ActiveState-cls1_Pr1","isSingleDisabled":"ActiveState-isSingleDisabled_CAa"};